export function normalizeReadyToShipDeadline(readyToShipDeadline: unknown): string | null {
  return typeof readyToShipDeadline === 'string' ? readyToShipDeadline : null;
}
